import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { OfferAcceptor } from "./type";

const useOfferAcceptorsApi = () => {
  const baseurl = "/offer_acceptors";

  const api = useApi();

  const searchOfferAcceptors = useCallback(
    async (query: PaginationQuery, signal?: AbortSignal) => {
      const url = buildUrl(baseurl, query);
      const data = await api.get<Paginated<OfferAcceptor>>({ url, signal });
      return data.items;
    },
    [api],
  );

  return {
    // useUsers,
    searchOfferAcceptors,
  };
};

export default useOfferAcceptorsApi;
